import React from 'react';
import SaveCTA from '../component/common/savecta';
import Contentsubpagemenu from '../component/layout/content-sub-page-menu';
import Header2 from '../component/common/title';
import pic26 from '../assets/pic26.png'
import Input from '../component/common/input';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Textarea from '../component/common/textarea';
import Uploadcta from '../component/common/uploadcta';
import Cta from '../component/common/cta';
import Popup from '../component/common/popup';
import Selectinput from '../component/common/selectinput';



const Contentmanagementhome = () => {

const [search, setSearch] = useState('');

        const [popup, setPopup] = useState([]);

        useEffect(() => {
        const getPopup = async()=>{
            const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;
        setPopup(res.data);
        };
        getPopup();
        }, []);



         const [ContactCTA, setContactCTA] = useState("");       
        const [Emaill, setEmaill] = useState("");
                const [Phone, setPhone] = useState("");
             const [LocationText, setLocationText] = useState("");
            const [Contact, setContact] = useState("");  
         const [Eventcta, setEventcta] = useState("");     
const [exhibitorsTitle, setExhibitorsTitle] = useState("");
         const [categoriesTitle, setCategoriesTitle] = useState("");
        const [Static, setStatic] = useState([]);
        const [heroTitle, setHeroTitle] = useState("");


        useEffect(() => {
        const getStatic = async()=>{
            const res = await supabase.from('static_content').select('*').order('id', { ascending: true });
            if (res.data) {
            setStatic(res.data);
            setHeroTitle(res.data?.[0]?.header || "");
              setExhibitorsTitle(res.data?.[3]?.header || "");
            setCategoriesTitle(res.data?.[2]?.header || "");
            setEmaill(res.data?.[5]?.sentence || "");
             setPhone(res.data?.[6]?.sentence || "");
                setContact(res.data?.[4]?.header || ""); 
              setLocationText(res.data?.[7]?.sentence || "");     
              setEventcta(res.data?.[33]?.cta || "");     
                  setContactCTA(res.data?.[4]?.cta || "");         
              

            if (res.data[1]) {
                setAboutData({
                header: res.data[1].header || "",
                 paragraph: res.data[1].paragraph || "",
                sub_title: res.data[1].sub_title || "",
                         number: res.data[1].number || "",

                 sub_title2: res.data[1].sub_title2 || "",
                number2: res.data[1].number2 || "",
                    img_alt: res.data[1].img_alt || "",
                img: res.data[1].img || ""
                }); } }};
        getStatic();
        }, []);



        const [events, setEvents] = useState([]);

        const [selectedEvent, setSelectedEvent] = useState("");
        const [eventData, setEventData] = useState(null);
        useEffect(() => {
        const fetchData = async () => {

            const { data, error } = await supabase
            .from("exbition_event")
            .select("*")
            .order("id", { ascending: true });

            if (error) {
            console.log(error);   return; }
            setEvents(data || []);
            const ongoingEvent = data.find(
                  (event) => event.status === "ongoing"  );

            if (ongoingEvent) {
            setSelectedEvent(ongoingEvent.id);
            setEventData(ongoingEvent);  } };

        fetchData();
        }, []);




const handleEventChange = (e) => {
  const newEventId = e.target.value;
  setSelectedEvent(newEventId);
  const selected = events.find(item => item.id == newEventId);
  setEventData(selected);
};






// useEffect(() => {
//   const getExhibitors = async () => {
//     const { data, error } = await supabase
//       .from("exhibitors").select("*").order('id', { ascending: true });
//     if (error) { console.log(error.message); return; }
//     setExhibitors(data || []);
//     const featured = data.filter(e => e.is_featured);
//     const filled = Array(3).fill("");
//     featured.forEach((ex, i) => {
//       const slot = ex.featured_position != null ? ex.featured_position - 1 : i;
//       if (slot >= 0 && slot < 3) filled[slot] = ex.id;
//     });
//     setSelectedExhibitors(filled);
//     setDataReady(true); 
//   };
//   getExhibitors();
// }, []);



        // useEffect(() => {
        // if (!selectedEvent) return;

        // const getEventContent = async () => {
        //     const { data, error } = await supabase
        //     .from("exbition_event")
        //     .select("*")
        //     .eq("id", selectedEvent)
        //     .single();

        //     if (error) {
        //     console.log(error);
        //     return; }  setEventData(data); };

        // getEventContent();
        // }, [selectedEvent]);





        const [aboutData, setAboutData] = useState({
        header: "",
        paragraph: "",
        sub_title: "",
           number: "",
        sub_title2: "",
         number2: "",
        img_alt: "",
        img: ""
        });




            const [selectedCategories, setSelectedCategories] = useState( Array(8).fill(""));
            const [categoryOptions, setCategoryOptions] = useState([]);

            useEffect(() => {
            const getCategoryOptions = async () => {
                const { data } = await supabase.from("category").select("*");
                setCategoryOptions(data || []);
            };
            getCategoryOptions();
            }, []);


            useEffect(() => {
            const init = async () => {

                const { data: allCategories } = await supabase.from("category").select("*");
                setCategoryOptions(allCategories || []);

               const { data: homepageCategories } = await supabase
                .from("category")
                  .select("*")
                 .eq("is_homepage", true);

                if (homepageCategories && homepageCategories.length > 0) {const filled = Array(8).fill("");
                  homepageCategories.forEach((cat, i) => {
                    if (i < 8) filled[i] = cat.id; });
                setSelectedCategories(filled);}  }; init();}, []);








const [Exhibitors, setExhibitors] = useState([]);
const [selectedExhibitors, setSelectedExhibitors] = useState(Array(3).fill(""));

useEffect(() => {
  const getExhibitors = async () => {
    const { data, error } = await supabase
      .from("exhibitors").select("*").order('id', { ascending: true });
    if (error) { console.log(error.message); return; }
    setExhibitors(data || []);
    const featured = data.filter(e => e.is_featured);
    const filled = Array(3).fill("");
    featured.forEach((ex, i) => {
      const slot = ex.featured_position != null ? ex.featured_position - 1 : i;
      if (slot >= 0 && slot < 3) filled[slot] = ex.id;
    });
    setSelectedExhibitors(filled);
  };
  getExhibitors();
}, []);









    const [img, setimg]= useState([]);

    useEffect(() => {
    const getimg = async()=>{
        const res = await supabase.from('images_scroll_repeated_sections').select('*');

    setimg(res.data);
    }
    getimg();
    }, []);





const updateImgField = (index, field, value) => {
  setimg((prev) =>
    prev.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    )
  );
};

const [showScrollImagePopup, setShowScrollImagePopup] = useState(false);
const [scrollImageIndex, setScrollImageIndex] = useState(null);
const [scrollImageLink, setScrollImageLink] = useState('');



const [showPopup2, setShowPopup2] = useState(false);
const closePopup2 = () => {
  setShowPopup2(false);
};


const saveAll = async () => {

  await supabase
    .from("static_content")
    .update({ header: heroTitle })
    .eq("id", Static?.[0]?.id);

  await supabase
    .from("exbition_event")
    .update({ hero_title: heroTitle })
    .eq("id", selectedEvent);

  await supabase
    .from("static_content")
    .update({
      header: aboutData.header,
      paragraph: aboutData.paragraph,
      sub_title: aboutData.sub_title,
      number: aboutData.number,
      sub_title2: aboutData.sub_title2,
      number2: aboutData.number2,
      img_alt: aboutData.img_alt,
      img: aboutData.img
    })
    .eq("id", Static?.[1]?.id);

  const validIds = selectedCategories.filter(id => id !== "" && id !== null && id !== undefined);
  if (validIds.length > 0) {
    await supabase.from("category").update({ is_homepage: false }).not("id", "is", null);
    for (const id of validIds) {
      await supabase.from("category").update({ is_homepage: true }).eq("id", id);
    }
  }

  await supabase
    .from("static_content")
    .update({ header: categoriesTitle })
    .eq("id", Static?.[2]?.id);

      const validExhibitorIds = selectedExhibitors
        .filter(id => id !== "" && id !== null && id !== undefined)
        .map(id => Number(id));
      if (validExhibitorIds.length > 0) {
        await supabase.from("exhibitors").update({ is_featured: false }).not("id", "is", null);
        for (const id of validExhibitorIds) {
          await supabase.from("exhibitors").update({ is_featured: true }).eq("id", id);
        }
      }

  await supabase
    .from("static_content")
    .update({ header: exhibitorsTitle })
    .eq("id", Static?.[3]?.id);

  for (const item of img) {
    await supabase.from("images_scroll_repeated_sections")
      .update({ img: item.img, alt: item.alt }).eq("id", item.id);
  }

        await supabase.from("static_content").update({ sentence: Emaill }).eq("id", Static?.[5]?.id);
        await supabase.from("static_content").update({ sentence: Phone }).eq("id", Static?.[6]?.id);
        await supabase.from("static_content").update({ sentence: LocationText }).eq("id", Static?.[7]?.id);
        await supabase.from("static_content").update({ header: Contact }).eq("id", Static?.[4]?.id);
        await supabase.from("static_content").update({ cta: ContactCTA }).eq("id", Static?.[4]?.id);
        await supabase.from("static_content").update({ cta: Eventcta }).eq("id", Static?.[33]?.id);

  await supabase.from("exbition_event").update({ status: "ended" }).eq("status", "ongoing");
  await supabase.from("exbition_event").update({ status: "ongoing" }).eq("id", selectedEvent);

            const { data: refreshedEvents } = await supabase
              .from("exbition_event")
              .select("*")
              .order("id", { ascending: true });
            if (refreshedEvents) {
              setEvents(refreshedEvents);
            }

      const { data: refreshedExhibitors } = await supabase
        .from("exhibitors")
        .select("*")
        .order("id", { ascending: true });
      if (refreshedExhibitors) {
        setExhibitors(refreshedExhibitors);
           const featured = refreshedExhibitors.filter(e => e.is_featured);
        const filled = Array(3).fill("");
        featured.forEach((ex, i) => { if (i < 3) filled[i] = ex.id; });
        setSelectedExhibitors(filled);
      }

      const { data: refreshedCategories } = await supabase
        .from("category")
        .select("*");
      if (refreshedCategories) {
        setCategoryOptions(refreshedCategories);
           const homepageOnes = refreshedCategories.filter(c => c.is_homepage);
        const filled = Array(8).fill("");
        homepageOnes.forEach((cat, i) => { if (i < 8) filled[i] = cat.id; });
        setSelectedCategories(filled);
      }

      setShowPopup2(true);
    };



const [showImagePopup, setShowImagePopup] = useState(false);
const [selectedId, setSelectedId] = useState(null);
const [imageLink, setImageLink] = useState('');



const sections = [
  { key: 'hero', name: 'Hero Section' },
   { key: 'event', name: 'Event Section' },
  { key: 'about', name: 'About Section' },
   { key: 'categories', name: 'Exhibition Categories Section' },
  { key: 'exhibitors', name: 'Featured Exhibitors Section' },

    { key: 'scroll', name: 'Scroll Images Section' },
  { key: 'contact', name: 'Contact us' },
];










    return ( 

 <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Content Management"  
                            para="Manage website content and pages dynamically"
                            />
                            

                          <section className='container-table2-eventp'>
                            

                            <Contentsubpagemenu />


                            <section className='container-table-eventp'>
                                <fieldset className="input-wrapper">
                                    <input 
                                    className='input-search'
                                     placeholder="Search by section name ..."
                                       value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                   
                                    />

                                     <img src={pic26} className="search-icon" alt="search" />
                                 </fieldset>

                                <section className='container-navigation-content'>

                                    <article className='container-part1-navigation-content'>
                                        <article className='header-container-content-change-p'>
                                            <h2 className='header-content-change-page'>Home Page Content</h2>
                                            <p className='para-content-change-page'>Manage website home page content</p>
                                        </article>

                                        <section className='containerr-inputs-content-changeee-page'>
  
                                                     
        
                                             <section className='sub-container-popup-content-management'>


                                                {(!search || 'hero section'.includes(search.toLowerCase())) && (
                                                 <section className='popup-content-main-container'>
                                                        <h2 className='popup-name'>Hero Section </h2>
                                                        <section className='input-container-popup-content'>
                                                            <Input title='Hero Title'
                                                            value={heroTitle}
                                                            onChange={(e) => setHeroTitle(e.target.value)}/>

                                                        </section>
                                                 </section>
                                                        )}








                                                {(!search || 'event section'.includes(search.toLowerCase())) && (
                                                 <section className='popup-content-main-container'>
                                                        <h2 className='popup-name'>Event Section </h2>
                                                        <section className='input-container-popup-content'>

                                                            <Selectinput
                                                            title="Choose Event"
                                                            value={selectedEvent}
                                                            onChange={handleEventChange}
                                                            options={events.map((e) => ({
                                                                value: e.id,
                                                                label: `${e.event_name} (${e.status})`
                                                            }))}
                                                            />



                                                                <Input title='Section Button'
                                                               value={Eventcta}
                                                            onChange={(e) => setEventcta(e.target.value)}                                                                  
                                                                />


                                                        </section>
                                                </section>
                                                      )}






                                              {(!search || 'about section'.includes(search.toLowerCase())) && (
                                                 <section className='popup-content-main-container'>
                                                        <h2 className='popup-name'>About Section </h2>
                                                        <section className='input-container-popup-content'>
                                                            <Input title='Section Title'
                                                             value={aboutData.header}
                                                                onChange={(e) =>setAboutData({
                                                                    ...aboutData,
                                                                    header: e.target.value })}/>


                                                            <Textarea title='Section paragraph'
                                                              stylee='main-text-area'
                                                           value={aboutData.paragraph}
                                                                onChange={(e) =>setAboutData({
                                                                    ...aboutData,
                                                                    paragraph: e.target.value  })}></Textarea>


                                                            <section className='row-navigation-inputs'>
                                                                <Input title='Title Statistics 1'    value={aboutData.sub_title}
                                                                onChange={(e) => setAboutData({ ...aboutData,
                                                                    sub_title: e.target.value})}/>

                                                                  <Input title='Number Statistics 1'   value={aboutData.number}
                                                                        onChange={(e) => setAboutData({
                                                                            ...aboutData,
                                                                            number: e.target.value}) }/>
                                                            </section>



                                                              <section className='row-navigation-inputs'>
                                                                <Input title='Title Statistics 1'  value={aboutData.sub_title2}
                                                                    onChange={(e) => setAboutData({
                                                                        ...aboutData,
                                                                        sub_title2: e.target.value }) }/>

                                                                  <Input title='Number Statistics 1'      value={aboutData.number2}
                                                                    onChange={(e) =>    setAboutData({
                                                                        ...aboutData,
                                                                        number2: e.target.value})}/>

                                                            </section>                                                          


                                                            <Input title='Pic name'
                                                              value={aboutData.img_alt} onChange={(e) =>
                                                                    setAboutData({
                                                                    ...aboutData, img_alt: e.target.value }) } />


                                                            <fieldset className='container0img-uploadd-popup'>
                                                                <label className='title-inputt'>Section Image</label>
                                                                    <fieldset className='main-img-upload-popup'>
                                                                    <img
                                                                    className='img-in-popups'
                                                                    src={aboutData.img}
                                                                    alt='popup'
                                                                    />

                                                                        <Uploadcta
                                                                        title='Upload Image'
                                                                        onClick={() => {
                                                                            setShowImagePopup(true);
                                                                             }} />
                                                                </fieldset>

                                                                {showImagePopup && (
                                                                <article className="container-popup" >
                                                                    <article className="cont2-popup">                                                           
                                                                    <Input
                                                                    title='Paste Image Link'
                                                                        type="text"
                                                                        placeholder="https://..."
                                                                        value={imageLink}
                                                                        onChange={(e) => setImageLink(e.target.value)}/>

                                                                    <nav className='container-ctas-craete'>
                                                                    <Cta
                                                                        title='Save Image'
                                                                        onClick={() => {
                                                                                if (!imageLink) return;
                                                                            setAboutData((prev) => ({
                                                                            ...prev,
                                                                                    img: imageLink          }));
                                                                            setShowImagePopup(false);
                                                                            setImageLink(''); }}/>

                                                                    <button className='cta-cancel-create' onClick={() => setShowImagePopup(false)}>
                                                                        <h2 className='cta-cancel-text-create'>Cancel</h2>
                                                                    </button>

                                                                    </nav>

                                                                    </article>
                                                                </article>
                                                                )}

                                                            </fieldset>






                                                        </section>
                                                 </section>
                                                    )}








                                    {categoryOptions.length > 0 && (
                                            <section className='popup-content-main-container'>
                                              <h2 className='popup-name'>Exhibition Categories Section</h2>
                                              <section className='input-container-popup-content'>
                                                <Input
                                                  title='Section Title'
                                                  value={categoriesTitle}
                                                  onChange={(e) => setCategoriesTitle(e.target.value)}
                                                />
                                                <section className='input-container-popup-content-categories'>
                                                  {selectedCategories.map((val, index) => (
                                                    <Selectinput
                                                      key={index}
                                                      title={`Homepage Category ${index + 1}`}
                                                      value={val}
                                                      onChange={(e) => {
                                                        const updated = [...selectedCategories];
                                                        updated[index] = e.target.value;
                                                        setSelectedCategories(updated);
                                                      }}
                                                      options={categoryOptions.map((c) => ({
                                                        value: c.id,
                                                        label: c.category_name
                                                      }))}
                                                    />
                                                  ))}
                                                </section>
                                              </section>
                                            </section>

)}
                                             






                                   
{Exhibitors.length > 0 && (
                                            <section className='popup-content-main-container'>
                                              <h2 className='popup-name'>Featured Exhibitors Section</h2>
                                              <section className='input-container-popup-content'>
                                                <Input
                                                  title='Section Title'
                                                  value={exhibitorsTitle}
                                                  onChange={(e) => setExhibitorsTitle(e.target.value)}
                                                />
                                                <section className='input-container-popup-content-categories'>
                                                  {[0, 1, 2].map((i) => (
                                                    <Selectinput
                                                      key={i}
                                                      title={`Exhibitors Name ${i + 1}`}
                                                      value={selectedExhibitors[i]}
                                                      onChange={(e) => {
                                                        const updated = [...selectedExhibitors];
                                                        updated[i] = e.target.value;
                                                        setSelectedExhibitors(updated);
                                                      }}
                                                      options={Exhibitors.map((item) => ({
                                                        value: item.id,
                                                        label: item.exhibitor_name
                                                      }))}
                                                    />
                                                  ))}
                                                </section>
                                              </section>
                                            </section>
)}





                                                              {(!search || 'scroll images section'.includes(search.toLowerCase())) && (

                                                            <section className='popup-content-main-container'>
                                                            <h2 className='popup-name'>Scroll Images Section</h2>
                                                            <section className='input-container-popup-content'>

                                                                {img?.map((item, index) => (
                                                                <React.Fragment key={item.id || index}>

                                                                    <fieldset className='container0img-uploadd-popup'>
                                                                    <label className='title-inputt'>Scroll Image {index + 1}</label>
                                                                        <fieldset className='main-img-upload-popup'>
                                                                            <img className='img-in-popups' src={item.img} alt='popup' />
                                                                            <Uploadcta  title='Upload Image'   onClick={() => {
                                                                                setScrollImageIndex(index);
                                                                                setShowScrollImagePopup(true); }}/>
                                                                        </fieldset>
                                                                    </fieldset>

                                                                    <Input
                                                                    title={`Scroll Image ${index + 1} Name`}
                                                                    value={item.alt || ''}
                                                                    onChange={(e) => updateImgField(index, 'alt', e.target.value)} />

                                                                </React.Fragment> ))}

                                                                {showScrollImagePopup && (
                                                                <article className="container-popup">
                                                                    <article className="cont2-popup">
                                                                     <Input
                                                                        title='Paste Image Link' type="text" placeholder="https://..."
                                                                        value={scrollImageLink} onChange={(e) => setScrollImageLink(e.target.value)}/>
                                                                        <nav className='container-ctas-craete'>
                                                                            <Cta  title='Save Image' onClick={() => {
                                                                                 if (!scrollImageLink) return;
                                                                                updateImgField(scrollImageIndex, 'img', scrollImageLink);
                                                                                 setShowScrollImagePopup(false);
                                                                                setScrollImageLink(''); }} />
                                                                            <button className='cta-cancel-create' onClick={() => setShowScrollImagePopup(false)}>
                                                                            <h2 className='cta-cancel-text-create'>Cancel</h2>
                                                                            </button>
                                                                        </nav>
                                                                    </article>
                                                                </article>
                                                                )}

                                                            </section>
                                                            </section>



                                                              )}






                                                {(!search || 'contact us'.includes(search.toLowerCase())) && (
                                                 <section className='popup-content-main-container'>
                                                        <h2 className='popup-name'>Contact us </h2>
                                                        <section className='input-container-popup-content'>





                                                            <Input title='Section Title'
                                                             value={Contact}
                                                            onChange={(e) => setContact(e.target.value)}                                                           
                                                            />    

                                                            <Input title='button Title'

                                                             value={ContactCTA}
                                                            onChange={(e) => setContactCTA(e.target.value)}                                                           
                                                            />  


                                                            <Input title='Emaill'
                                                             value={Emaill}
                                                            onChange={(e) => setEmaill(e.target.value)}                                                           
                                                            />                                                                

                                                            <section className='row-navigation-inputs'>
                                                                <Input title='Phone'
                                                               value={Phone}
                                                            onChange={(e) => setPhone(e.target.value)}                                                                  
                                                                />

                                                            </section>

                                                            <Textarea title='Location'
                                                              stylee='main-text-area'
                                                             value={LocationText}
                                                             onChange={(e) => setLocationText(e.target.value)} />



                                                            <Selectinput
                                                            title="Map for Event"
                                                            value={selectedEvent}     
                                                            onChange={handleEventChange}  
                                                            options={events.map(e => ({
                                                                value: e.id,
                                                                label: e.event_name
                                                            }))}
                                                            />

                                                        </section>
                                                </section>

                                                    )}







                                            
                                             </section>


                                        </section>

                                                    <button
                                                    className='container-save-cta'
                                                    onClick={saveAll}
                                                    
                                                >
                                                    <SaveCTA title='Save Changes' />
                                                </button>



                                    </article>





                                </section>











                            </section>
                            
                        </section>     
                            

                                
                                  
        </article>
                            {showPopup2 && (
                            <Popup
                            to="/content-management-navigations" 
                                onClose={closePopup2}
                            img={popup?.[2]?.image} 
                                alt={popup?.[2]?.icon_alt} 
                            header={popup?.[2]?.title}
                            para={popup?.[2]?.paragraph} 
                            title={popup?.[2]?.cta_text_primary} 
                            />
                    )}


</section>
     );
}
 
export default Contentmanagementhome;